import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { PaymentCartService } from 'src/app/shared/services';

@Component({
    selector: 'app-lib-cart-alert',
    standalone: false,
    templateUrl: './cart-alert.component.html',
    styleUrl: './cart-alert.component.scss',
})
export class CartAlertComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public isPaymentsDuplicates: boolean;
    public isPaymentsMixes: boolean;

    constructor(private paymentCartService: PaymentCartService) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.subscribeErrors();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeErrors(): void {
        combineLatest([this.paymentCartService.isThereDuplicatesToPay$(), this.paymentCartService.isThereMixesToPay$()])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: ([isPaymentsDuplicates, isPaymentsMixes]) => {
                    this.isPaymentsDuplicates = !isPaymentsDuplicates.isValid;
                    this.isPaymentsMixes = !isPaymentsMixes.isValid;
                },
            });
    }
}
